
export default function roundPow2(n) {
    return 2 ** Math.round(Math.log2(n));
}
